import Axios from 'axios'
//import router from './router'
//import store from './store'

let uri = window.location.search.substring(1);
let qs = new URLSearchParams(uri);

const axios = Axios.create({
    baseURL: process.env.VUE_APP_WIDGET_API + '/'
});

/*
axios.interceptors.request.use(request => {
    const api_token = localStorage.getItem('api_token');
    if (api_token) {
        request.headers.Authorization = 'Bearer ' + api_token;
    }
    return request;
});
*/

import demo from '~/sample_api.json';

export default {
    'getUser': async function () {
        const response = await axios.get('auth/user');

        return response.data.data;
    },
    'getAreas': async function () {
        const response = await axios.get('widget/areas');
        return response.data;
    },
    'getMetrics': async function (org_id) {
        const response = await axios.get('widget/organizations/' + org_id + '/metrics');
        return response.data;
    },
    'getMetricValues': async function (key) {
        //const resp2 = demo;
        const r = demo;
        //return { data: r };

        const response = await axios.get('widget/load/' + key, {});
        return response.data;
    },
};
